import axios from 'axios';

/**
 * Extract a user-facing message from an API error, preferring the backend's
 * FastAPI `detail` field over the generic axios message. `detail` may be a string,
 * a list of 422 validation errors, or an object with a `message` (429 rate limits).
 */
export const getApiErrorMessage = (err: unknown, fallback: string): string => {
  if (axios.isAxiosError(err)) {
    const detail = err.response?.data?.detail;
    if (typeof detail === 'string' && detail) return detail;
    if (Array.isArray(detail) && detail.length > 0) {
      return detail.map((d: { msg?: string }) => d?.msg).filter(Boolean).join(', ') || fallback;
    }
    if (
      detail &&
      typeof detail === 'object' &&
      typeof detail.message === 'string' &&
      detail.message
    ) {
      return detail.message;
    }
    return fallback;
  }
  return err instanceof Error && err.message ? err.message : fallback;
};
